import { Outlet } from 'react-router';
import NavBar from '@/component/dashboard-inc/navBar';
import { SidebarProvider, useSidebarContext } from '@common/layout/sidebar/SidebarProvider';
import { MobileDrawer } from '@common/layout/sidebar/MobileDrawer';
import { DesktopSidebar } from '@common/layout/sidebar/DesktopSidebar';
import { SidebarContent } from '@common/layout/sidebar/SidebarContent';
import { VendorSetupBanner } from '@common/vendor/VendorSetupBanner';
import { BecomeVendorBanner } from '@common/vendor/BecomeVendorBanner';
import { NavigationProgress } from './NavigationProgress';

/**
 * DashboardLayout - Dashboard layout with Sidebar and NavBar.
 * Used for authenticated dashboard pages (orders, profile, etc).
 * Child routes render via <Outlet />.
 */
export function DashboardLayout({ title }) {
  return (
    <SidebarProvider>
      <DashboardLayoutInner title={title} />
    </SidebarProvider>
  );
}

// Inner component to use sidebar context hooks
function DashboardLayoutInner({ title }) {
  const {
    mobileDrawerOpen,
    openMobileDrawer,
    closeMobileDrawer,
    desktopCollapsed,
    toggleDesktopSidebar,
  } = useSidebarContext();

  return (
    <div className="wrapper" id="wrapper">
      <NavigationProgress />

      {/* Mobile Drawer (Radix UI) */}
      <MobileDrawer
        open={mobileDrawerOpen}
        onOpenChange={(open) => {
          if (!open) {
            closeMobileDrawer();
          } else {
            openMobileDrawer();
          }
        }}
      >
        <SidebarContent onLinkClick={closeMobileDrawer} isCollapsed={false} />
      </MobileDrawer>

      {/* Desktop Sidebar */}
      <DesktopSidebar collapsed={desktopCollapsed} onToggle={toggleDesktopSidebar}>
        <SidebarContent onLinkClick={undefined} isCollapsed={desktopCollapsed} />
      </DesktopSidebar>

      <div id="page-content-wrapper">
        <NavBar title={title} />
        <div className="dashboard-content">
          {/* The gap between the top bar and the first banner belongs to this
              strip (see .dashboard-announcements in _wrapper.scss): the pages
              carry their own top gap in .main_div, and a banner above them has
              none of its own, so the become-a-vendor announcement sat flush
              against the top bar. */}
          <div className="dashboard-announcements">
            <VendorSetupBanner />
            {/* Never both: the setup banner is for vendors, and the backend
                lists this announcement only for someone who is not one. */}
            <BecomeVendorBanner />
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default DashboardLayout;
